import React, { Component } from 'react';
import Aux from '../../hoc/Aux';
import * as messages from '../../messages';
import classes from './TransactionCompleted.css';

class TransactionCompleted extends Component {
    render() {
        return <Aux>Dziękujemy za dokonane zakupy. Mamy nadzieję, że produkt spełni Twoje oczekiwania.</Aux>;
    };
}

export default TransactionCompleted;